// extracted by mini-css-extract-plugin
module.exports = {"sign_in_connect_button":"ConnectButton_sign_in_connect_button__yh_Jm","sign_in_connect_button_text":"ConnectButton_sign_in_connect_button_text__nDi0_"};